<template>
  <div class="w-full">
    <a-input-group compact style="display:flex;">
      <!-- <a-select
          :value="selectVal"
          @select="selectChange"
          style="min-width: 60px;flex:1"
          placeholder="请选择"
          allowClear
        >
          <a-select-option
            v-for="item in options"
            :value="item?.code"
            :key="item?.code"
            >{{ item?.title }}</a-select-option
          >
        </a-select> -->
      <a-input
        :style="{ flex: 1 }"
        :value="inputVal"
        @input="iptChange"
        placeholder="请输入"
        allowClear
      />
      <div ref="target" style="width:46px;">
        <a-button @click="onShow">
          <file-search-outlined />
        </a-button>
        <div class="text-area" v-if="isVisible">
          <p class="pb-4">批量搜索</p>
          <a-textarea
            :rows="8"
            placeholder="批量输入，以换行区分"
            v-model:value="value2"
            @change="onChange"
          />

          <div class="text-right mt-4">
            <a-button @click="cancel">取消</a-button>
            <a-button class="ml-4" type="primary" @click="handleOk"
              >确定</a-button
            >
          </div>
        </div>
      </div>
    </a-input-group>
  </div>
</template>

<script>
import { reactive, ref, toRefs, defineComponent, computed, inject } from 'vue'
import { FileSearchOutlined } from '@ant-design/icons-vue'
import { onClickOutside } from '@vueuse/core'

export default defineComponent({
  name: 'InputExteds',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    inputVal: {
      type: String,
      default: () => ''
    },
    selectVal: {
      type: Number,
      default: () => 0
    },
    textareaVal: {
      type: String,
      default: () => ''
    },
    be: {
      type: String,
      default: () => 'prd' // prd 商品列表  cmt 产品列表
    }
  },
  emits: ['ok', 'update:input-val', 'update:select-val'],
  setup(props, context) {
    const initState = inject('state')

    const state = reactive({
      value1: '',
      value2: '',
      isVisible: false,
      iptChange(e) {
        const val = e.target.value.replace(/，/g, ',')
        context.emit('update:input-val', val)
        sessionStorage.setItem(props.be + '-searchKey', val)
        initState.initData()
      },
      selectChange(v) {
        context.emit('update:select-val', v)
        sessionStorage.setItem(props.be + '-searchType', v)
      },
      handleOk() {
        const textarea = state.value2.toString()
        const isEntry = textarea.includes('\n')
        const isComma = textarea.includes(',')
        let val = []
        // 回车
        if (isEntry) {
          val = textarea.split('\n')
          console.log(2)
        } else if (isComma) {
          // 英文逗号
          console.log(1)
          val = textarea.split(',')
        } else {
          val = textarea.split()
        }

        // const arr = Array.from(new Set(val));
        const res = val.map(e => e.replaceAll(/\s/g, '')).filter(e => e !== '')
        context.emit('ok', Array.from(new Set(res)))
        sessionStorage.setItem(
          props.be + '-searchKey',
          Array.from(new Set(res))
        )
        state.isVisible = false
      },
      cancel() {
        // state.value2 = ''
        state.isVisible = false
      },
      onShow() {
        state.isVisible = !state.isVisible
        state.value2 = props.inputVal
      },
      onChange() {
        console.log(state.value2, 'state.value2')
        state.value2 = state.value2.replace(/ /g, ',')
      },
      inputStyle: computed(() => {
        let style = { width: 'calc(100% - 100px)', transition: 'none' }
        // if (props.selectVal === 2) {
        style.width = 'calc(100% - 100px - 46px)'
        // }
        return style
      })
    })

    const target = ref(null)
    onClickOutside(target, () => {
      state.isVisible = false
    })

    return {
      ...toRefs(state),
      target
    }
  },
  components: { FileSearchOutlined }
})
</script>

<style lang="scss" scoped>
.text-area {
  padding: 14px;
  background: #fff;
  width: 80%;
  position: absolute;
  right: 0;
  top: 36px;
  transition: height 2s, transform 2s;
  z-index: 1050;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
}
</style>
